import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { ToastController } from 'ionic-angular';
import { Auth } from '../../providers/auth';

import { PlayPage } from '../play/play';
import { HomePage } from '../home/home';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { GamerulesModel } from '../../providers/gamerules-model';
import { DataExchanger } from '../../providers/data-exchanger';

@Component({
  selector: 'page-versuspvpasync',
  templateUrl: 'versuspvpasync.html',
  host: { '(window:resize)': 'handleResizeEvents($event)' }
})
export class VersusPVPAsyncPage {
  language: string;
  settingsChanged: boolean;
  usernamePlayerChosenToStartPvpAsync: string = '';
  playerData;
  gamesdataPVPAsync: any = [];
  refreshIntervalId;
  randomPlayerData: any;
  socket;

  constructor(public rubedoSideMenu: MenuController, public functions: Functions, public toastCtrl: ToastController, public auth: Auth, public translate: TranslateService, public navCtrl: NavController, public gamesrulesModel: GamerulesModel, public userdataModel: UserdataModel, public dataExchanger: DataExchanger, public playModel: GameModel) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);

    this.language = '';
    this.settingsChanged = false;
    this.socket = this.functions.getSocket();


    //Socket fix for avoid the 2 seconds set interval update on db
    var that = this;
    this.socket.on('PvpAsyncDataStored', function (data) { 
     // console.log(data)
     console.log("In PvpAsyncDataStored Socket return")
     var waitUpdate = setInterval(function () {
      clearInterval(waitUpdate);
      that.dataExchanger.getVersusPVPAsyncGames().then((response) => {
        console.log("PvpAsyncDataStored UPDATED");
      });
      }
      , 2500);
    })

    this.socket.on('PvpAsyncDataUpdated', function (data) { 
      // console.log(data)
      console.log("In PvpAsyncDataUpdated Socket return")
      var waitUpdate = setInterval(function () {
       clearInterval(waitUpdate);
       that.dataExchanger.getVersusPVPAsyncGames().then((response) => {
         console.log("PvpAsyncDataUpdated UPDATED");
       });
       }
       , 2500);
     })
  }

  goToMainMenu() {
    this.navCtrl.setRoot(HomePage, {});
  }

  /* --------- LIFECYCLE --------- */
  ionViewWillLeave() {
    //before the page leaves the viewport
    this.functions.setLanguage();
    if (this.settingsChanged) {
      this.dataExchanger.storeUserGamedataOnServer(true);
      console.log("Setting changed... saving on server");
    }
    this.settingsChanged = false;
    clearInterval(this.refreshIntervalId);
  }

  ionViewWillEnter() {
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);
    this.functions.getLanguage();
    this.settingsChanged = false;

    this.dataExchanger.getVersusPVPAsyncGames().then((response) => {
    });
  }

  ionViewDidEnter() {
    this.functions.setScaleForBigScreen();
  }

  handleResizeEvents(event: KeyboardEvent) {
    this.functions.setScaleForBigScreen();
  }
  /* --------- END LIFECYCLE --------- */

  startPVPAsync() {
    /*
    -- Possible statuses -- 
    sent: first game, challenge sent
    accepted: second game, replying to game sent, challenge accepted
    declined: refuse a challenge
    rewarded: collecting reward for ended challenge

    Async mode Flow:
      In a normal flow we have two games ('sent' by Plr1 and 'accepted' by Plr2)
      - Plr1 starts a game (classic with no playback). At the end the game is saved and 'sent' field filled
      - Plr2 finds out the challenge and accept it. The field idGameVersus of the 'sent' game is filled with the id of this game.
        Plr2 plays with playback of the first game.
        At the end the game is saved and 'accepted' field filled.
        The two games are updated with status 'win_versus' or 'lost_versus'
      - Then Plr1  and Pl2 see their game('sent' for Plr1 and 'accepted' for Plr2) and allowed to get a reward. 
        When they hit the button for the reward the status 'rewarded' is set to their game (So to keep track of the two different reward)
      - Alternatively, Plr1 can decide to decline his own game. In this case, only one game is available ('sent') and the status 'declined'
        is set to it. 'win' is set to 'lost_versus'
      - Alternatively, Plr2 can decide to decline Plr1 game. In this case, only one game is available ('sent') and the status 'declined'
        is set to it.  'win' is set to 'win_versus'. This separates the two cases (declined by Plr1 or Plr2)
    */
    if (this.usernamePlayerChosenToStartPvpAsync != '') {
      if (this.userdataModel.getUsername() == this.usernamePlayerChosenToStartPvpAsync) {
        this.functions.showMessageTranslated(this.toastCtrl, "playerSelf");
      } else {
        this.dataExchanger.checkIfPlayerExistFromUsername(this.usernamePlayerChosenToStartPvpAsync).then((response) => {
          this.playerData = response;
          if (this.playerData.playerExists) {
            this.functions.setGameModeVersusPVPAsync(true);
            this.functions.setGuidChallengerPvpAsync(this.playerData.guidUser);
            this.functions.setUsernameChallengerPvpAsync(this.usernamePlayerChosenToStartPvpAsync);
            this.functions.setGameSentVersusPVPAsync();
            this.navCtrl.push(PlayPage, {});
          } else {
            this.functions.showMessageTranslated(this.toastCtrl, "playerNotExist");
          }
        });
      }
    } else {
      this.dataExchanger.chooseRandomPlayer().then((response) => {
        this.randomPlayerData = response;
        if (this.randomPlayerData.guidUser) {
          this.functions.setGameModeVersusPVPAsync(true);
          this.functions.setGuidChallengerPvpAsync(this.randomPlayerData.guidUser);
          this.functions.setUsernameChallengerPvpAsync(this.randomPlayerData.username);
          this.functions.setGameSentVersusPVPAsync();
          this.navCtrl.push(PlayPage, {});
        } else {
          this.functions.showMessageTranslated(this.toastCtrl, "challengerNotFound");
        }
      });
    }
  }

  acceptChallengePVPAsync(singleGameData) {
    this.functions.setGameModeVersusPVPAsync(true);
    this.functions.setGameAcceptedVersusPVPAsync();

    this.functions.setGuidChallengerPvpAsync(singleGameData.guidUser);
    this.functions.setIdGameSentVersusPVPAsync(singleGameData.idGame);
    this.functions.setLanguageBookSentVersusPVPAsync(singleGameData.language);

    this.navCtrl.push(PlayPage, {});
  }

  declinePVPAsync(singleGameData) {
    /* If I declined */
    singleGameData.declined = this.functions.currentTimestamp();
    singleGameData.win = "win_versus";
    this.dataExchanger.setDataGameStatusVersusPVPAsync(singleGameData.idGame, singleGameData.guidUser, "declined").then((response) => { });
    this.dataExchanger.setDataGameWinVersusPVPAsync(singleGameData.idGame, singleGameData.guidUser, "win_versus").then((response) => { });
  }

  declineYourOwnChallengePVPAsync(singleGameData) {
    /* decline settare win lost&win su entrmabe le partite */
    singleGameData.declined = this.functions.currentTimestamp();

    this.dataExchanger.setDataGameStatusVersusPVPAsync(singleGameData.idGame, singleGameData.guidUser, "declined").then((response) => { });
    this.dataExchanger.setDataGameWinVersusPVPAsync(singleGameData.idGame, singleGameData.guidUser, "lost_versus").then((response) => { });
  }

  //Pop up for check game result
  rewardPVPAsync(singleGameData) {
    if (singleGameData.win == "win_versus" || singleGameData.win == "lost_versus") {
      this.dataExchanger.addOutGameBonusPointToScoreAndAdjustLevel(this.functions.bonusScore[singleGameData.win + "PVPAsync"]);
    }

    singleGameData.rewarded = this.functions.currentTimestamp();
    this.dataExchanger.setDataGameStatusVersusPVPAsync(singleGameData.idGame, singleGameData.guidUser, "rewarded").then((response) => { });

    var pointsGained = singleGameData.scoreFinal - singleGameData.scoreInitial;
    var message='';
    if (singleGameData.win == "win_versus") {
      if (this.functions.language == 'it') {
        message="<h1><strong>HAI VINTO!</h1></strong>Hai guadagnato " + pointsGained + " punti e " + this.functions.bonusScore[singleGameData.win + "PVPAsync"] + " punti bonus!";
        if (this.auth.barbicanEventActive) {
          message=message+" Continua a giocare da casa su xtribe.eu/rubedo!";
        }
      }
      if (this.functions.language == 'en') {
        message="<h1><strong>YOU WIN!</h1></strong>You gained " + pointsGained + " points e " + this.functions.bonusScore[singleGameData.win + "PVPAsync"] + " bonus points!";
        if (this.auth.barbicanEventActive) {
          message=message+" Continue playing at home at xtribe.eu/rubedo!";
        }
        this.functions.showWalkthroughWithMessage(message, "superhappy");
      }
      this.functions.showWalkthroughWithMessage(message, "superhappy");
    }
    if (singleGameData.win == "lost_versus") {
      if (this.functions.language == 'it') {
        message="<h1><strong>HAI PERSO!</h1></strong>Giocando, hai comunque guadagnato " + pointsGained + " punti!";
        if (this.auth.barbicanEventActive) {
          message=message+" Continua a giocare da casa su xtribe.eu/rubedo!";
        }
      }
      if (this.functions.language == 'en') {
        message="<h1><strong>YOU LOST!</h1></strong>By playing, you gained " + pointsGained + " points, anyway!";
        if (this.auth.barbicanEventActive) {
          message=message+" Continue playing at home at xtribe.eu/rubedo!";
        }
      }
      this.functions.showWalkthroughWithMessage(message, "supersad");
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/versuspvpasync/versuspvpasync.ts